import axios from 'axios'
import { Toast } from 'vant';

var urlArr = window.location.hash.split('/');
var identity = urlArr.indexOf('user') == 1 ? 'user' : 'agent';
var envBaseURL;
if(identity == 'user'){
    envBaseURL = process.env.VUE_APP_USER_BASE_API;
}else{
    envBaseURL = process.env.VUE_APP_AGENT_BASE_API;
}

const service = axios.create({
    baseURL: envBaseURL
})

service.interceptors.request.use(
    config => {
        var token = localStorage.getItem('token');
        config.headers.common['token'] = token;

        var appid = localStorage.getItem('appid');
        config.headers.common['appid'] = appid;

        var iccid = localStorage.getItem('iccid');
        config.headers.common['iccid'] = iccid;

        Toast.loading({message: '加载中...', duration:0, forbidClick: true});
        return config;      
    },
    err => {
        return Promise.reject(err)      
    }
)

service.interceptors.response.use(
    res => {
        Toast.clear();
        return res;
    },
    err => {
        return Promise.reject(err)
    }
)

export default service;